import { connect } from "react-redux"
import { activate } from "../../redux/actions/auth/auth"
import { Navigate, useNavigate } from "react-router-dom";


function ActivateAccount({
    uid,
    token,
    activate,
    isAuthenticated
}) {

  const navigate = useNavigate() 
  
  const onSubmit = e => {
      e.preventDefault();
      activate(uid, token)
      navigate('/')
  }

  if(isAuthenticated){
    return <Navigate to='/'/>
  }

    return (
      <>
        <div className="flex h-screen flex-1 flex-col justify-center px-6 lg:px-8">

          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <h2 className="mt-10 leading-tight text-center text-5xl font-bold leading-9 text-gray-900 mb-5">
              Activa tu cuenta
            </h2> 
          </div>
  
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form onSubmit={e=>{onSubmit(e)}} method='POST' className="space-y-6">
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-blue-green px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-green"
                >
                  Activar
                </button>
            </form>
          </div>
        </div>
      </>
    )
}

const mapStateToProps=state=>({
  isAuthenticated: state.auth.isAuthenticated
})

export default connect (mapStateToProps, {
    activate,
})(ActivateAccount)